/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from '@/plugins/axios';

const actions = {
  //Setting State Value For Calculator

  setCurrentCalculation({ commit }, currentcal) {
    commit('CALCULATOR_CURRENT', currentcal);
  },

  // Add Products in Sales
  changeProductprice({ commit }, product) {
    commit('UPDATE_PRODUCT_NEW_PRICE', product);
  },
  // Add Products in Sales
  AddNewProductToSales({ commit }, product) {
    commit('ADD_PRODUCT_NEW', product);
  },
  // Add Products in Sales
  AddUnitPerticularProductPrices({ commit }, product) {
    commit('ADD_PRODUCT_PRICE_PERTICULAR_PRODUCT', product);
  },
  // Add Products in Sales
  AddProductToSales({ commit }, product) {
    commit('ADD_PRODUCT', product);
  },
  // Add Unit Perticular Product in Sales
  AddUnitPerticularProduct({ commit }, product) {
    commit('ADD_UNIT_PERTICULAR_PRODUCT', product);
  },
  // Fetch the all country list
  GetCountries({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('countries/search')
        .then((res) => {
          if (res.status == 200) {
            commit('SET_COUNTRIES', res.data.data);

            resolve(res);
          }
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  //set default page
  SetProductSize({ commit }, payload) {
    commit('SET_PAGE_SIZE', payload);
  },
  // Pagination Settings
  GetPaginationSettings({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('settings/pagination/')
        .then((resp) => {
          commit('SET_PAGINATION_SETTING', resp.data.data[0]);

          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  // Fetch Pagination Data
  GetPaginationData({}, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(payload.url, { params: payload.params })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  // Fetch Auto Completion Data
  GetAutoCompleteData({}, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(payload.url, { params: payload.params })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  // POS Settings
  async createSale({}, Credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post('sales', Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  async UpdatePosSetting({}, Credentials) {
    delete Credentials.category;
    delete Credentials.shop;
    delete Credentials.customerGroup;
    delete Credentials.customerType;
    delete Credentials.id;

    return new Promise((resolve, reject) => {
      axios
        .patch('settings/pos-configuration/1', Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  async GetPOSSettings({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`settings/pos-configuration/1`)

        .then((resp) => {
          commit('SET_POS_URL', resp.data.pos_url);
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  /* ========================= Roles ========================= */
  GetRoles() {
    return new Promise((resolve, reject) => {
      axios
        .get('roles/search')
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  /* =========================  File Uploads ========================= */
  async DocumentUploads({}, fd) {
    var formData = new FormData();
    for (var i = 0; i < fd.files.length; i++) {
      formData.append('image', fd.files[i]);
    }
    return new Promise((resolve, reject) => {
      axios
        .post(`document/upload/${fd.documentType}/${fd.fileId}`, formData)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  /* =========================  Files View ========================= */
  async DocumentView({}, fd) {
    return new Promise((resolve, reject) => {
      axios
        .get(`document/${fd.documentType}/${fd.fileId}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  /* =========================  Files View ========================= */
  setErrorMessages({ commit }, payload) {
    commit('SET_SERVER_MESSAGES', payload.error);
  },
  setCaluclatorSettings({ commit }, payload) {
    commit('SET_Calculator_SETTING', payload);
  },
  GetProductBatches({}, payload) {
    let url = `stocks/${payload.id}/batches/search?`;
    url += `except=[${payload.selectedBatches}]`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetTimeFormat({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('timeformat')
        .then((resp) => {
          commit('SET_TIME_FORMATS', resp.data);
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
};

export default actions;
